import { atom } from 'jotai'
import { callListAtom } from '~/atoms/WebphoneState'

/** Session only: Later hides the recommended banner until the next launch. */
export const recommendedUpdateDismissedAtom = atom(false)

export const hasActiveCallAtom = atom((get) => get(callListAtom).size > 0)

/**
 * Formats a `YYYY-MM-DD` value as a local calendar date. Parsing it with
 * `new Date(value)` would read it as UTC midnight and show the previous day
 * west of UTC.
 */
export const formatRequiredByDate = (
  value: string,
  locale: string,
): string | null => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (!match) {
    return null
  }
  const [, year, month, day] = match.map(Number)
  const date = new Date(year, month - 1, day)
  if (date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null
  }
  return date.toLocaleDateString(locale, { month: 'long', day: 'numeric' })
}
